import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const UpArrow = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    data-temporary-fix
    data-test="up-arrow"
    height={height}
    width={width}
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M8 6L11.4641 9.75H4.5359L8 6Z" fill={getColor(color, isColorInherited)} />
  </SvgIcon>
);
